import FormMultiPartUpload, { FileData, VideoURLData } from './FormMultiPartUpload';

export default FormMultiPartUpload;
export type { FileData, VideoURLData };
